import { render, staticRenderFns } from "./iconFacebook.vue?vue&type=template&id=f6864b88"
import script from "./iconFacebook.vue?vue&type=script&lang=js"
export * from "./iconFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports